import api from "@/api";
import Supplier from "@/models/Supplier";
export default class Part {
  constructor(rawdata = {}) {
    this.id = rawdata.id ? rawdata.id : 0;
    this.part_no = rawdata.part_no ? rawdata.part_no : "";
    this.description = rawdata.description ? rawdata.description : "";
    // this.supplier_id = rawdata.supplier_id ? rawdata.supplier_id : "";
    this.re_order_pt = rawdata.re_order_pt ? rawdata.re_order_pt : 0;
    this.location = rawdata.location ? rawdata.location : "";
    // this.batch_no = rawdata.batch_no ? rawdata.batch_no : "";
    // this.price = rawdata.price ? rawdata.price : 0;
    // this.remarks = rawdata.remarks ? rawdata.remarks : "";
    // this.quantity = rawdata.quantity ? rawdata.quantity : 0;
    this.image_path = rawdata.image_path ? rawdata.image_path : "";

    this.stocks = [];
    if ("stocks" in rawdata) {
      this.stocks = rawdata.stocks;
    }
  }

  static async getSupplier(supplier_id) {
    if (!supplier_id) return null;

    return Supplier.fetch(this.supplier_id).then(resp => {
      return resp;
    });
  }

  static async fetch(payload) {
    const result = await api.get(`/api/v1/parts/part/${payload}/`);
    if (result && result.status == 200) return result.data.data[0];
    return null;
  }

  static async create(payload) {
    const result = await api.post("/api/v1/parts/create/", payload);
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async put(payload) {
    const result = await api.put(`/api/v1/parts/${payload.id}/`, payload);
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async getStocks(part_id) {
    const result = await api.get(`/api/v1/stockout/scan/?part_id=${part_id}`);
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async consumeStocks(payload) {
    const result = await api.post(`/api/v1/stockout/`, payload, "json");
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async updateStocks(payload) {
    const result = await api.put(
      `/api/v1/stockout/update/${payload.id}/`,
      payload,
      "json"
    );
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static async stockouts(params) {
    const result = await api.get(`/api/v1/stockout/list/`, params);
    if (result && result.status == 200) return result.data;

    return null;
  }

  static async stockout(id) {
    const result = await api.get(`/api/v1/stockout/list/?id=${id}`);
    if (result && result.status == 200) return result.data.data[0];

    return null;
  }

  static async getGlossary() {
    const result = await api.get("/api/v1/parts/all/");
    if (result && result.status == 200) {
      return result.data.data;
    }
    return null;
  }

  static rules() {
    return {
      description: [
        {
          required: true,
          message: "Part description is required.",
          trigger: "blur"
        }
      ],
      part_id: [
        {
          required: true,
          message: "Part number is required.",
          trigger: "change"
        }
      ],
      part_no: [
        { required: true, message: "Part number is required.", trigger: "blur" }
      ],
      supplier_id: [
        { required: true, message: "Supplier is required.", trigger: "blur" }
      ],
      re_order_pt: [
        {
          required: true,
          message: "Re-order amount is required.",
          trigger: "blur"
        }
      ],
      location: [
        { required: true, message: "Location is required.", trigger: "blur" }
      ]
      // image_path: [
      //   { required: true, message: "Image is required.", trigger: "blur" }
      // ]
      // remarks: [
      //   { required: true, message: "Remarks is required.", trigger: "blur" }
      // ],
      // quantity: [
      //   { required: true, message: "Quantity is required.", trigger: "blur" }
      // ],
      // price: [
      //   { required: true, message: "Price is required.", trigger: "blur" }
      // ]
    };
  }
}
